import { getSessionObject } from './storage';
export const detectTheme = urlParams => {
  const app = urlParams.get('app') ?? getSessionObject('env')?.app ?? null;
  const prefersDark = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const theme = prefersDark ? 'dark' : 'light';
  return app === 'libre1' ? theme : 'light';
};
export const getTheme = urlParams => {
  const THEME_MAP = {
    adcLight: 'light',
    adcDark: 'dark'
  };
  const themeParam = urlParams.get('theme');
  if (themeParam && themeParam in THEME_MAP) {
    return THEME_MAP[themeParam];
  }
  return detectTheme(urlParams);
};